import { render, staticRenderFns } from "./respond-to-nobodies.vue?vue&type=template&id=bd4e0ce4"
import script from "./respond-to-nobodies.vue?vue&type=script&lang=js"
export * from "./respond-to-nobodies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports